// === Menu === //
const navToggler = () => {
  const navToggle = document.querySelector(".menu__toggle")
  const menuMobile = document.querySelector(".mobile-menu")
  // const page = document.querySelector("body");

  if (navToggle !== null) {
  navToggle.addEventListener("click", (event) => {
      menuMobile.classList.toggle("mobile-menu--open");
      // page.classList.toggle("no-scroll");
      navToggle.classList.toggle("menu__toggle--close");
  });
  }
};
navToggler ();

// === Mobile submenu === //
const mobileSubmenu = document.querySelectorAll(".mobile-submenu");

mobileSubmenu.forEach(mobileSubmenu => {
  mobileSubmenu.addEventListener("click", () => {
    mobileSubmenu.classList.toggle("active");
    });
});

// === Mega Menu === //
const megaMenu = () => {
  const menuToggler = document.querySelector(".menu-toggler");
  const menuOverlay = document.querySelector(".mega-menu");
  const completeOverlay = document.querySelector(".complete-overlay-menu");
  const menuSection = document.querySelector(".menu-section");
  const menuItem = document.querySelectorAll(".menu__nav__item a");
  const logo = document.querySelector(".logo");

  if (menuToggler !== null) {
    menuToggler.addEventListener("click", (event) => {
      menuOverlay.classList.toggle("mega-menu--open");
      completeOverlay.classList.toggle("complete-overlay-menu--open");
      menuSection.classList.toggle("mega-menu-active");
      menuItem.forEach(function (menuItem) {
        menuItem.classList.toggle("mega-menu-active");
      });
      logo.classList.toggle("mega-menu-active");
    });
  }

  if (completeOverlay !== null) {
    completeOverlay.addEventListener("click", (event) => {
      menuOverlay.classList.toggle("mega-menu--open");
      completeOverlay.classList.toggle("complete-overlay-menu--open");
      menuSection.classList.toggle("mega-menu-active");
      menuItem.forEach(function (menuItem) {
        menuItem.classList.toggle("mega-menu-active");
      });
      logo.classList.toggle("mega-menu-active");
    });
  }

};
megaMenu();

// Product slider
var swiper = new Swiper(".productSlider", {
  slidesPerView: 2,
  spaceBetween: 20,
  keyboard: {
    enabled: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + "</span>";
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});


var swiper = new Swiper(".product-gallery__thumb", {
  spaceBetween: 15,
  slidesPerView: 8,
  // freeMode: true,
  watchSlidesProgress: true,
  keyboard: {
    enabled: true,
  },
});
var swiper2 = new Swiper(".product-gallery", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});

